import React, {Suspense} from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from "@mui/material";
import {createUseStyles} from 'react-jss'

const useStyles = createUseStyles({
    wait: {
        minHeight: '100vh'
        ,width: '100%'
        ,minWidth: '100%'
        ,display: 'flex'
        ,flexDirection: 'column'
        ,alignItems: 'center'
        ,justifyContent: 'center'
    }
});

const useStyles2 = createUseStyles({
    show: {
        display: (props)  => {
            //console.log(props.keyRef, props.selKeyRef, props.keyRef === props.selKeyRef, props)
            return props.show ? 'flex' : 'none'
        }
    }
});

export default function ShowLazyPanel(props){
   
    const classes = useStyles();
    const classShow = useStyles2(props);
   
    const[render, setRender] = React.useState(false)
    const[Modulo, setModulo] = React.useState(<></>)

    React.useEffect(() => {
        
        if (classShow)
            if (props.show && !render) {
                if (props.lazyModule) {
                    setModulo(props.lazyModule);
                    setRender(true)
                }
            }
    }, [props.show, props.lazyModule, render])

    
    return (render ? 
        <Suspense fallback={<div className={classes.wait}><CircularProgress color={props.color} /> Cargando {props.label}, espere un momento..</div>} >
            <div className={classShow.show}><Modulo {...props.options}/></div>
        </Suspense> 
        : null
    )
}

ShowLazyPanel.defaultProps = {
    show : false
    ,color: "secondary"
    ,options:{}
}

ShowLazyPanel.propTypes = {
    show: PropTypes.bool.isRequired
}